import type { BuyAiAnswersResponse } from 'src/openapi';
import { formatToFetchError } from 'src/helpers/utils';
import apiClient from 'src/helpers/apiClient';
import appApi from './index';

const aiCreditsApi = appApi.injectEndpoints({
  endpoints: (build) => ({
    // Shared with the Chrome extension's own top-up button -- same pack, same
    // price, same grant, so an AI credit bought here is indistinguishable from
    // one bought there. `quantity` is the vault dialog's pack stepper.
    buyAiCredits: build.mutation<BuyAiAnswersResponse, { quantity: number }>({
      queryFn: async ({ quantity }) => {
        try {
          const { data } = await (
            await apiClient.getAutofillApi()
          ).autofillChromeExtensionApiBuyAiAnswers({
            buyAiAnswersBody: { quantity },
          });
          return { data };
        } catch (err: any) {
          return formatToFetchError(err);
        }
      },
    }),
  }),
});

export const { useBuyAiCreditsMutation } = aiCreditsApi;

export default aiCreditsApi;
